export const AUTH_USER = 'auth_user';
export const UNAUTH_USER = 'unauth_user';
export const AUTH_ERROR = 'auth_error';
export const USER_LOGOUT = "user_logout";

export const ESTIMATION_UPDATE_STEP = 'estimation_update_step';
export const ESTIMATION_COMPUTE_SUCCESS = "estimation_compute_success";
export const ESTIMATION_COMPUTE_ERROR = "estimation_compute_error";
export const ESTIMATION_COMPUTE_RESET = "estimation_compute_reset";
export const ESTIMATION_MAIL_SUCCESS = "estimation_mail_success";

export const SELLER_INDEX='seller_index';
export const UPDATE_INFO_FORM_IMG = "update_info_form_img";

export const VALORISATION_GET_TABLE = 'valorisation_get_table';
export const VALORISATION_ACTIVE_TABLE = 'valorisation_active_table';

export const VALORISATION_CLICK_NEXT = 'valorisation_click_next';
export const VALORISATION_CLICK_PROGRESS_BAR = 'valorisation_click_progress_bar';
export const VALORISATION_GET_QUESTIONS = 'valorisation_get_questions';
export const VALORISATION_GET_TABLE_UNIVERSAL = "valorisation_get_table_universal";
export const VALORISATION_COMPUTE_VALORISATION = "valorisation_compute_valorisation";

export const DIAGNOSTIC_GET_DIAGNOSTIC = "diagnostic_get_diagnostic";

